import React, { Component } from "react";
import { View, TouchableOpacity, Text, StyleSheet, Dimensions, Platform } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";

export default class KeyboardBar extends Component {
  render() {
    const { abcOptionPress, scanOptionPress } = this.props;
    return (
      <View style={styles.container}>
        {abcOptionPress && (
          <TouchableOpacity onPress={abcOptionPress} style={styles.btn}>
            <Text style={styles.txt}>ABC</Text>
          </TouchableOpacity>
        )}
        {scanOptionPress && (
          <TouchableOpacity onPress={scanOptionPress} style={styles.btn}>
            <Text style={styles.txt}>
              <Icon name="qrcode-scan" size={20} />
            </Text>
          </TouchableOpacity>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#EDEEEE",
    flexDirection: "row",
    width: Dimensions.get("screen").width,
    padding: Platform.OS === "ios" ? 10 : 5,
    paddingLeft: 10,
    paddingRight: 0,
  },
  btn: { backgroundColor: "lightgray", width: "20%", padding: 5, borderRadius: 5, marginRight: 15 },
  txt: { textAlign: "center" },
});
